import { createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-617de888")

_pushScopeId("data-v-617de888")
const _hoisted_1 = { class: "col-12 col-sm-12 col-xl" }
const _hoisted_2 = { class: "card-body d-flex justify-content-center text-center flex-column p-8" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "symbol symbol-75px mb-6" }, [
  /*#__PURE__*/_createVNode("img", {
    src: "media/svg/files/folder-document.svg",
    alt: ""
  })
], -1)
const _hoisted_4 = { class: "fs-5 fw-bolder mb-2 text-truncate px-2" }
const _hoisted_5 = { class: "fs-7 fw-bold text-gray-400 mt-auto" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "card h-100 team-material-card",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('open')))
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("a", {
          href: "#",
          class: "text-gray-800 text-hover-primary d-flex flex-column",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('open')), ["prevent"]))
        }, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.folderName), 1)
        ]),
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.files) + " items", 1),
        (_ctx.canManage)
          ? (_openBlock(), _createBlock("div", {
              key: 0,
              class: "d-flex justify-content-center gap-2 mt-3",
              onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light-primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('rename')))
              }, "Rename"),
              _createVNode("button", {
                type: "button",
                class: "btn btn-sm btn-light-danger",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('delete')))
              }, "Delete")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
})